/**
 * Collection de citations inspirantes de grandes figures du business
 * Utilisées pendant le chargement de l'analyse pour créer une expérience engageante
 */

export interface BusinessQuote {
  text: string;
  author: string;
  role?: string;
}

export const businessQuotes: BusinessQuote[] = [
  // Winston Churchill
  {
    text: "Le succès, c'est aller d'échec en échec sans perdre son enthousiasme.",
    author: "Winston Churchill",
    role: "Premier ministre britannique"
  },
  {
    text: "L'attitude est une petite chose qui fait une grande différence.",
    author: "Winston Churchill",
    role: "Premier ministre britannique"
  },
  {
    text: "Le pessimiste voit la difficulté dans chaque opportunité. L'optimiste voit l'opportunité dans chaque difficulté.",
    author: "Winston Churchill",
    role: "Premier ministre britannique"
  },

  // Steve Jobs
  {
    text: "L'innovation distingue un leader d'un suiveur.",
    author: "Steve Jobs",
    role: "Co-fondateur d'Apple"
  },
  {
    text: "Votre temps est limité, ne le gâchez pas en menant une existence qui n'est pas la vôtre.",
    author: "Steve Jobs",
    role: "Co-fondateur d'Apple"
  },
  {
    text: "La seule façon de faire du bon travail est d'aimer ce que vous faites.",
    author: "Steve Jobs",
    role: "Co-fondateur d'Apple"
  },
  {
    text: "Restez affamés, restez fous.",
    author: "Steve Jobs",
    role: "Co-fondateur d'Apple"
  },

  // Peter Drucker
  {
    text: "La meilleure façon de prédire l'avenir est de le créer.",
    author: "Peter Drucker",
    role: "Père du management moderne"
  },
  {
    text: "L'efficacité consiste à faire les bonnes choses. L'efficience consiste à bien faire les choses.",
    author: "Peter Drucker",
    role: "Père du management moderne"
  },
  {
    text: "Ce qui se mesure s'améliore.",
    author: "Peter Drucker",
    role: "Père du management moderne"
  },
  {
    text: "Le marketing vise à connaître et comprendre le client si bien que le produit ou service lui convient parfaitement et se vend de lui-même.",
    author: "Peter Drucker",
    role: "Père du management moderne"
  },

  // Robert Collier
  {
    text: "Le succès est la somme de petits efforts répétés jour après jour.",
    author: "Robert Collier",
    role: "Auteur et copywriter"
  },
  {
    text: "Visualisez ce que vous voulez, énergisez votre désir, et il se manifestera.",
    author: "Robert Collier",
    role: "Auteur et copywriter"
  },
  {
    text: "Votre problème n'est jamais vraiment votre problème. Votre réaction à votre problème est votre problème.",
    author: "Robert Collier",
    role: "Auteur et copywriter"
  },

  // Paulo Coelho
  {
    text: "Quand vous voulez quelque chose, tout l'univers conspire à vous permettre de réaliser votre désir.",
    author: "Paulo Coelho",
    role: "Auteur de L'Alchimiste"
  },
  {
    text: "Il n'y a qu'une façon d'apprendre, c'est par l'action.",
    author: "Paulo Coelho",
    role: "Auteur de L'Alchimiste"
  },
  {
    text: "N'ayez pas peur de prendre des risques. C'est en prenant des risques que nous grandissons.",
    author: "Paulo Coelho",
    role: "Auteur de L'Alchimiste"
  },

  // David Ogilvy
  {
    text: "Le consommateur n'est pas un imbécile, c'est votre femme.",
    author: "David Ogilvy",
    role: "Père de la publicité moderne"
  },
  {
    text: "Si ça ne vend pas, ce n'est pas créatif.",
    author: "David Ogilvy",
    role: "Père de la publicité moderne"
  },
  {
    text: "Plus vous informez, plus vous vendez.",
    author: "David Ogilvy",
    role: "Père de la publicité moderne"
  },
  {
    text: "Dans le monde moderne des affaires, il est inutile d'être un penseur créatif à moins de pouvoir également vendre ce que vous créez.",
    author: "David Ogilvy",
    role: "Père de la publicité moderne"
  },

  // Henry Ford
  {
    text: "Que vous pensiez être capable ou ne pas être capable, dans les deux cas, vous avez raison.",
    author: "Henry Ford",
    role: "Fondateur de Ford Motor Company"
  },
  {
    text: "L'échec est simplement l'opportunité de recommencer, cette fois de façon plus intelligente.",
    author: "Henry Ford",
    role: "Fondateur de Ford Motor Company"
  },
  {
    text: "Se réunir est un début, rester ensemble est un progrès, travailler ensemble est la réussite.",
    author: "Henry Ford",
    role: "Fondateur de Ford Motor Company"
  },

  // Warren Buffett
  {
    text: "Il faut 20 ans pour construire une réputation et cinq minutes pour la détruire.",
    author: "Warren Buffett",
    role: "Investisseur et PDG de Berkshire Hathaway"
  },
  {
    text: "Le risque vient de ne pas savoir ce que vous faites.",
    author: "Warren Buffett",
    role: "Investisseur et PDG de Berkshire Hathaway"
  },
  {
    text: "Le prix est ce que vous payez. La valeur est ce que vous obtenez.",
    author: "Warren Buffett",
    role: "Investisseur et PDG de Berkshire Hathaway"
  },

  // Richard Branson
  {
    text: "Les opportunités sont comme les bus, il y en a toujours un autre qui arrive.",
    author: "Richard Branson",
    role: "Fondateur du groupe Virgin"
  },
  {
    text: "Si quelqu'un vous offre une opportunité incroyable et que vous n'êtes pas sûr de pouvoir le faire, dites oui - puis apprenez comment le faire plus tard.",
    author: "Richard Branson",
    role: "Fondateur du groupe Virgin"
  },

  // Jeff Bezos
  {
    text: "Votre marque est ce que les gens disent de vous quand vous n'êtes pas dans la pièce.",
    author: "Jeff Bezos",
    role: "Fondateur d'Amazon"
  },
  {
    text: "Si vous doublez le nombre d'expériences que vous faites par an, vous doublez votre inventivité.",
    author: "Jeff Bezos",
    role: "Fondateur d'Amazon"
  },

  // Bill Gates
  {
    text: "Le succès est un mauvais professeur. Il pousse les gens intelligents à penser qu'ils ne peuvent pas perdre.",
    author: "Bill Gates",
    role: "Co-fondateur de Microsoft"
  },
  {
    text: "Vos clients les plus mécontents sont votre plus grande source d'apprentissage.",
    author: "Bill Gates",
    role: "Co-fondateur de Microsoft"
  },

  // Mark Zuckerberg
  {
    text: "Le plus grand risque est de ne prendre aucun risque.",
    author: "Mark Zuckerberg",
    role: "Co-fondateur de Facebook"
  },
  {
    text: "Avancez vite et cassez les choses. Si vous ne cassez rien, c'est que vous n'allez pas assez vite.",
    author: "Mark Zuckerberg",
    role: "Co-fondateur de Facebook"
  },

  // Sam Walton
  {
    text: "Il n'y a qu'un patron : le client. Et il peut licencier tout le monde dans l'entreprise en dépensant son argent ailleurs.",
    author: "Sam Walton",
    role: "Fondateur de Walmart"
  },
  {
    text: "Célébrez vos succès. Trouvez de l'humour dans vos échecs. Ne vous prenez pas trop au sérieux.",
    author: "Sam Walton",
    role: "Fondateur de Walmart"
  },

  // Zig Ziglar
  {
    text: "Vous n'avez pas à être grand pour commencer, mais vous devez commencer pour être grand.",
    author: "Zig Ziglar",
    role: "Auteur et conférencier motivateur"
  },
  {
    text: "Vous pouvez avoir tout ce que vous voulez dans la vie si vous aidez suffisamment d'autres personnes à obtenir ce qu'elles veulent.",
    author: "Zig Ziglar",
    role: "Auteur et conférencier motivateur"
  }
];

/**
 * Obtient une citation aléatoire de la collection
 */
export const getRandomQuote = (): BusinessQuote => {
  const randomIndex = Math.floor(Math.random() * businessQuotes.length);
  return businessQuotes[randomIndex];
};

/**
 * Obtient une série de citations uniques pour une session
 * @param count Nombre de citations à retourner
 */
export const getUniqueQuotes = (count: number): BusinessQuote[] => {
  const shuffled = [...businessQuotes].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, businessQuotes.length));
};
